/* eslint-disable*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataGridCustomLink from './DataGridCustomLink';
import {
  Grid,
  Input,
} from '../../../components/index';
import {
  DtpContentContainer,
} from 'dtp-react-components';

class RemuneracaoControlItem extends Component {
  constructor() {
    super();
    this.state = {
      ano: null,
    };
  }

  exibirValor = (parametro) => {
    let retorno = '';
    const index = this.props.remuneracoesPreenchidas.findIndex(r => (r.competencia === parametro));
    if (index !== -1) {
      retorno = this.props.remuneracoesPreenchidas[index].valor;
    }
    return retorno;
  }

  textoDestaque = texto => {
    return (
      <React.Fragment>
        <span style={{
          zIndex: '1',
          background: 'none',
          height: '5.9rem',
          position: 'relative',
          top: '2.6rem',
          display: 'block',
          width: '100%',
          fontSize: '1.6rem',
          marginBottom: '1rem',
          backgroundColor: '#ffffff',
          color: '#03a9f4',
          }}
        >
          {texto}
        </span>
      </React.Fragment>
    )
}

  // criarRemuneracoes = (ano) => {
  criarRemuneracoes = (ano) => {
    let colecao = [];
      this.props.remuneracoesAtividade.moedasCompetencia.forEach((item) => {
        if (ano === item.ano) {
          colecao.push(
            <div className="row">
              <Grid cols="2 2 2 2">
                {this.textoDestaque(item.competenciaFormatada)}
              </Grid>
              <Grid cols="2 2 2 2">
                {this.textoDestaque(item.sigla)}
              </Grid>
              <Grid cols="7 7 7 7">
                <Input
                  id={`${item.competencia.substring(0, 2)}-${item.ano}`}
                  label="Valor"
                  onChange={e => this.props.handleChange(e, `${item.competencia.substring(0, 2)}-${item.ano}`)}
                  value={this.exibirValor(`${item.competencia.substring(0, 2)}-${item.ano}`)}
                  currency
                  maxlength="16"
                  disabled={this.props.desabilitarCampos}
                />
              </Grid>
            </div>
          );
        }
      })
    return colecao;
  };

  render() {
    const retorno = (
      <DtpContentContainer>
        <React.Fragment>
          <DataGridCustomLink
            title={this.props.anoEscolhido}
            retirarLinhaSeparadora={false}
            cssLinha='header-com-linha'
            criarLink
            alertarPreenchimentoAutomatico={this.props.alertarPreenchimentoAutomatico}
            alertarLimpezaAutomatica={this.props.alertarLimpezaAutomatica}
            verificarHabilitacaoBotaoLimpeza={this.props.verificarHabilitacaoBotaoLimpeza}
            remuneracoesPreenchidas={this.props.remuneracoesPreenchidas}
            acao={this.props.acao}
          >
            {this.criarRemuneracoes(this.props.anoEscolhido)}
          </DataGridCustomLink>
        </React.Fragment>
      </DtpContentContainer>
    );
    return retorno;
  }
}

RemuneracaoControlItem.propTypes = {
  tabAtiva: PropTypes.string,
  remuneracoesAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  atualizarListaRemuneracao: PropTypes.func.isRequired,
  anoEscolhido: PropTypes.number.isRequired,
  remuneracoesPreenchidas: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
    valor: PropTypes.string,
  })).isRequired,
  desabilitarCampos: PropTypes.bool.isRequired,
  alertarPreenchimentoAutomatico: PropTypes.func.isRequired,
  acao: PropTypes.string,
  limparValoresAutomaticamente: PropTypes.func.isRequired,
  alertarLimpezaAutomatica: PropTypes.func.isRequired,
  verificarHabilitacaoBotaoLimpeza: PropTypes.func.isRequired,
};

export default RemuneracaoControlItem;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/RemuneracaoControlItem.jsx